import React, { useEffect, useState } from "react";
import { FormControl, Input, InputLabel } from "@material-ui/core";
import { Redirect } from "react-router";
import validator from "validator";
import { toast } from "react-toastify";
import axios from "axios";
const Intrestedinprogram = () => {
  const [certificatetype, setcertificatetype] = useState("Direct");
  const [name, setName] = useState("");
  const [namedisabled, setNamedisabled] = useState(false);
  const [lastnamedisabled, setLastnamedisabled] = useState(false);
  const [phonedisabled, setPhonedisabled] = useState(false);
  const [emaildisabled, setEmaildisabled] = useState(false);
  const [lastname, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [disabled, setdisabled] = useState(true);
  const [checkcoff, setcheckcoff] = useState(false);
  const [payredirect, setpayredirect] = useState(false);
  const [courseid, setcourseid] = useState("");
  const [coursefeeid, setcoursefeeid] = useState("");
  const [staticlink, setstaticlink] = useState("");
  const [btnvalue, setbtnvalue] = useState("Enroll");
  useEffect(() => {
    var localdata = JSON.parse(localStorage.getItem("data"));
    if (localdata) {
      if ( localdata?.learner?.mobileno &&(
        localdata?.learner?.mobileno !== null ||
        localdata?.learner?.mobileno !== "null" ||
        localdata?.learner?.mobileno !== undefined ||
        localdata?.learner?.mobileno !== "undefined" ||
        localdata?.learner?.mobileno !== null)
      ) {
        setPhone(localdata?.learner?.mobileno);
        setPhonedisabled(true);
      } else setPhone("");
      if (localdata?.person?.lastName && (
        localdata?.person?.lastName !== null ||
        localdata?.person?.lastName !== "null" ||
        localdata?.person?.lastName !== undefined ||
        localdata?.person?.lastName !== "undefined" ||
        localdata?.person?.lastName !== null)
      ) {
        setLastName(localdata?.person?.lastName);
        setLastnamedisabled(true);
      } else setLastName("");
      if (localdata?.person?.firstName &&(
        localdata?.person?.firstName !== null ||
        localdata?.person?.firstName !== "null" ||
        localdata?.person?.firstName !== undefined ||
        localdata?.learner?.firstName !== "undefined" ||
        localdata?.learner?.firstName !== null)
      ) {
        setName(localdata?.person?.firstName);
        setNamedisabled(true);
      } else setName("");
      if (localdata?.person?.username &&(
        localdata?.person?.username !== null ||
        localdata?.person?.username !== "null" ||
        localdata?.person?.username !== undefined ||
        localdata?.person?.username !== "undefined" ||
        localdata?.person?.username !== null)
      ) {
        setEmail(localdata?.person?.username);
        setEmaildisabled(true);
      } else setName("");
    }
  }, []);
  const enrollforcourse = () => {
    //setcheckcofflearn(true)
    // console.log(validator.isAlpha(lastname.trim()))
    // console.log(lastname)
    if (
      email === undefined ||
      lastname === undefined ||
      phone === undefined ||
      name === undefined ||
      email === null ||
      lastname === null ||
      phone === null ||
      name === null
    ) {
      toast.error("All fields are Mandetory*", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    if (
      email.trim() === "" ||
      lastname.trim() === "" ||
      phone.trim() === "" ||
      name.trim() === ""
    ) {
      toast.error("All fields are Mandetory*", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(name.trim())) {
      toast.error("Please Enter valid Name", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isAlpha(lastname.trim())) {
      toast.error("Please Enter valid Name2", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isNumeric(phone.trim())) {
      toast.error("Please Enter valid phone", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (phone.length <= 6) {
      toast.error("Please Enter Valid phone", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isEmail(email.trim())) {
      toast.error("Please Enter valid Email", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    let formData = new FormData();
    formData.append("firstname", name.trim());
    formData.append("lastname", lastname.trim());
    formData.append("email", email.trim());
    formData.append("phone", phone.trim());
    formData.append(
      "staticlink",
      window.location.pathname.replace("/course/", "")
    );
    formData.append("certificatetype", certificatetype);
    setbtnvalue("Enrolling..");
    setdisabled(false);
    axios
      .post("Payment/enroll", formData)
      .then((res) => {
        //   console.log(res.data)
        setbtnvalue("Enroll");
        setdisabled(true);
        if (res.data.status === "200" && res.data.message === "instructor") {
          toast.error("Please Create an Learner Account", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        }
        if (
          res.data.status === "200" &&
          res.data.message === "Already Register"
        ) {
          toast.warning("Already Register,Please Login ", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        }
        // localStorage.setItem("token", res.data.token);
        // localStorage.setItem("usertype", res.data.ut);
        // localStorage.setItem("name", res.data.name);
        // localStorage.setItem("initial",  res.data.initial);
        // localStorage.setItem("data",  JSON.stringify(res.data.mydata));
        // context.setUser({ email: res.data.user, token: res.data.token })
        if (
          res.data.status === "200" &&
          res.data.message === "course offering not found"
        ) {
          setcheckcoff(true);
          toast.error("Please Try After sometime", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          return res;
        } else if (
          res.data.status === "200" &&
          res.data.message === "success"
        ) {
          // localStorage.setItem("user", res.data.user);
          setcourseid(res.data.courseid);
          setcoursefeeid(res.data.coursefeeid);
          setstaticlink(res.data.staticlink);
          setEmail(res.data.user);
          if (res.data.account === "existing") {
            toast.success("Redirecting to payment page", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
          } else {
            toast.success(
              "Your account has been created successfully ,Please check email",
              {
                position: toast.POSITION.BOTTOM_LEFT,
              }
            );
          }
          setpayredirect(true);
          return res;
        }
        throw res;
      })
      .catch((error) => {});
  };
  if (checkcoff) {
    return <Redirect to="/" />;
  }
  if (payredirect) {
    // return <Redirect to="/" />;
    return (
      <Redirect
        to={{
          pathname: "/Payment/" + staticlink,
          state: {
            coursefeeid: coursefeeid,
            courseid: courseid,
            user: email,
          },
        }}
      />
    );
  }
  return (
    <div>
      <div class="row px-3">
        <div class="col-lg-12 ">
          <FormControl style={{ width: "100%" }}>
            <InputLabel htmlFor="standard-adornment-password">
              First Name
            </InputLabel>
            <Input
              className="mb-4"
              type="text"
              name="firstname"
              onChange={(e) => setName(e.target.value)}
              value={name}
              disabled={namedisabled}
              placeholder="First Name"
            />
          </FormControl>
        </div>
        <div class="col-lg-12 ">
          <FormControl style={{ width: "100%" }}>
            <InputLabel htmlFor="standard-adornment-password">
              Last Name
            </InputLabel>
            <Input
              className="mb-4"
              type="text"
              name="lasttname"
              onChange={(e) => setLastName(e.target.value)}
              value={lastname}
              disabled={lastnamedisabled}
              placeholder="Last Name"
            />
          </FormControl>
        </div>
        <div class="col-lg-12 ">
          <FormControl style={{ width: "100%" }}>
            <InputLabel htmlFor="standard-adornment-password">
              Phone Number
            </InputLabel>
            <Input
              className="mb-4"
              type="text"
              name="phonenumber"
              onChange={(e) => setPhone(e.target.value)}
              value={phone}
              disabled={phonedisabled}
              placeholder="Phone Number"
            />
          </FormControl>
        </div>
        <Input type="hidden" name="certificatetype" value={certificatetype} />
        <div class="col-lg-12 ">
          <FormControl style={{ width: "100%" }}>
            <InputLabel htmlFor="standard-adornment-password">Email</InputLabel>
            <Input
              className="mb-4"
              type="email"
              name="email"
              placeholder="Email"
              // disabled="true"
              disabled={emaildisabled}
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
          </FormControl>
        </div>
        <div class="row mb-5 px-5">
          <div class="col-lg-12 ">
            <button
              type="submit"
              onClick={enrollforcourse}
              disabled={!disabled}
              class="btn btn-blue text-center"
            >
              {btnvalue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intrestedinprogram;
